module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-ivoor-brillenmerk-verpakking-1.ed9cbe50.jpg";